import React from "react";
import Chart from "react-apexcharts";
import "../../assets/styles/dashboardItems.css";
import { useViewUsersWiseReport } from "../../hooks/reports/users";


const ActiveUserLineChart = () => {
  const { data, loading, error } = useViewUsersWiseReport();

  // Prepare chart data from API response
  const categories = Array.isArray(data) ? data.map(item => item.month) : [];
  const seriesData = Array.isArray(data) ? data.map(item => item.count) : [];

  const options = {
    chart: {
      id: "basic-line",
      animations: {
        enabled: false
      },
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    colors: ['#1bb50d'],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100]
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    title: {
      text: 'Active Users',
      align: 'left',
      style: {
        fontSize: '20px',
        color: '#333'
      }
    },
    grid: {
      row: {
        colors: ['#f8f9fa', 'transparent'],
        opacity: 0.5
      },
    },
    xaxis: {
      categories: categories,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            width: "100%",
            height: 300,
            toolbar: {
              show: false
            }
          },
          xaxis: {
            labels: {
              show: false
            }
          },
          title: {
            style: {
              fontSize: '16px'
            }
          }
        }
      }
    ]
  };

  const series = [
    {
      name: "Active Users",
      data: seriesData
    }
  ];

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error loading chart data.</div>;
  }
  return (
    <div className="graphChart" style={{
      display: 'block',
      width: '100%',
      background: '#b3f4c032',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      boxSizing: 'border-box',
      overflow: 'hidden'
    }}>
      <Chart
        options={options}
        series={series}
        type="area"
        height={350}
        width="100%"
      />
    </div>
  );
};
export default ActiveUserLineChart;